/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoles = (props) => (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "ndl-icon-svg" }, props, { children: _jsx("path", { d: "M16.7885 16.2222C16.3417 15.3354 15.6575 14.5901 14.812 14.0693C13.9665 13.5485 12.993 13.2728 12 13.2728C11.007 13.2728 10.0336 13.5485 9.18808 14.0693C8.3426 14.5901 7.65835 15.3354 7.21159 16.2222M22 10.1662C22.0004 13.0023 20.9962 15.7469 19.1657 17.9132C17.3351 20.0794 14.7965 21.5273 12 22C9.20355 21.5273 6.66489 20.0794 4.83433 17.9132C3.00376 15.7469 1.99962 13.0023 2 10.1662V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H20.6667C21.0203 2 21.3594 2.14048 21.6095 2.39052C21.8595 2.64057 22 2.97971 22 3.33333V10.1662ZM9 9C9 9.79565 9.31607 10.5587 9.87868 11.1213C10.4413 11.6839 11.2044 12 12 12C12.7956 12 13.5587 11.6839 14.1213 11.1213C14.6839 10.5587 15 9.79565 15 9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7956 6 12 6C11.2044 6 10.4413 6.31607 9.87868 6.87868C9.31607 7.44129 9 8.20435 9 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) })));
export default SvgRoles;
//# sourceMappingURL=Roles.js.map